<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.cutting.dialog.httperror' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ 'masterdata.cutting.rule' | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['name'].invalid && controls['name'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.name.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.name.label' | translate }}</mat-label>
				<input maxlength="50" matInput formControlName="name" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.description' | translate }}</mat-label>
				<input maxlength="100" matInput formControlName="description" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.batch-type.label' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="batchType" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.profile' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="profile" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.racking.rules.dialog.groupByProductionRoute' | translate }}</mat-label>
				<mat-select formControlName="groupByProductionRoute">
					<mat-option [value]="false">{{ 'general.table.status.inactive' | translate }}</mat-option>
					<mat-option [value]="true">{{ 'general.table.status.active' | translate }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.racking.rules.dialog.state.label' | translate }}</mat-label>
				<mat-select formControlName="state">
					@for (state of states; track state) {
					<mat-option [value]="state">{{ 'masterdata.racking.rules.dialog.state.' + state | translate }}</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.racksets' | translate }}</mat-label>
				<mat-select formControlName="rackset">
					<mat-option [value]="null">{{ 'masterdata.cutting.dialog.none' | translate }}</mat-option>
					@for (rackset of availableRacksets?.items; track rackset) {
					<mat-option [value]="rackset.self">{{ rackset.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['placementPriority'].invalid && controls['placementPriority'].touched) {
				<mat-error>{{ 'masterdata.racking.rules.dialog.placementPriorityError' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.rules.dialog.placementPriority' | translate }}</mat-label>
				<input OnlyPositiveIntegers matInput formControlName="placementPriority" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.segregation' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="segregation" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.racking.rules.dialog.optimization' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="optimization" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.productionSequenceNumberMode.label' | translate }}</mat-label>
				<mat-select formControlName="productionSequenceNumberMode">
					<mat-option value="Disabled">{{ 'masterdata.cutting.productionSequenceNumberMode.Disabled' | translate }}</mat-option>
					<mat-option value="Slave">{{ 'masterdata.cutting.productionSequenceNumberMode.Slave' | translate }}</mat-option>
					<mat-option value="Master">{{ 'masterdata.cutting.productionSequenceNumberMode.Master' | translate }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.racking.rules.dialog.slotConfiguration.label' | translate }}</mat-label>
				<mat-select formControlName="slotConfiguration">
					<mat-option value="MixElements">{{ 'masterdata.racking.rules.dialog.slotConfiguration.MixElements' | translate }}</mat-option>
					<mat-option value="MixCompleteElements">{{ 'masterdata.racking.rules.dialog.slotConfiguration.MixCompleteElements' | translate }}</mat-option>
					<mat-option value="SeparateElements">{{ 'masterdata.racking.rules.dialog.slotConfiguration.SeparateElements' | translate }}</mat-option>
					<mat-option value="GroupSimilarElements">{{ 'masterdata.racking.rules.dialog.slotConfiguration.GroupSimilarElements' | translate }}</mat-option>
				</mat-select>
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['slotsPerCell'].invalid && controls['slotsPerCell'].touched) {
				<mat-error>{{ 'masterdata.racking.rules.dialog.slotsPerCellError' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.rules.dialog.slotsPerCell' | translate }}</mat-label>
				<input matInput formControlName="slotsPerCell" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['logisticsFormula'].errors?.['api']; as error) {
				<mat-error>{{ error }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.logisticsFormula' | translate }}</mat-label>
				<textarea matInput formControlName="logisticsFormula" rows="3" maxlength="1000"></textarea>
			</mat-form-field>
		</div>

		<div class="checkbox-dialog-container">
			<mat-checkbox class="dialog-checkbox" formControlName="useCoatingInOptimization">{{ 'masterdata.racking.useCoatingInOptimization' | translate }}</mat-checkbox>
		</div>

		<h3>Aluminium</h3>
		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['material'].invalid) {
				<mat-error>{{ 'masterdata.racking.rules.dialog.aluminiumError' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.material.label' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="material" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['machine'].invalid) {
				<mat-error>{{ 'masterdata.racking.rules.dialog.aluminiumError' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.machines.label' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="machine" />
			</mat-form-field>
		</div>

		<h3>{{ 'masterdata.racking.rules.dialog.types' | translate }}</h3>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">Type 1</mat-label>
				<input maxlength="255" matInput formControlName="id0" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">Type 2</mat-label>
				<input maxlength="255" matInput formControlName="id1" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">Type 3</mat-label>
				<input maxlength="255" matInput formControlName="id2" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">Type 4</mat-label>
				<input maxlength="255" matInput formControlName="id3" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">Type 5</mat-label>
				<input maxlength="255" matInput formControlName="id4" />
			</mat-form-field>
		</div>
		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">Type 6</mat-label>
				<input maxlength="255" matInput formControlName="id5" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">Type 7</mat-label>
				<input maxlength="255" matInput formControlName="id6" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">Type 8</mat-label>
				<input maxlength="255" matInput formControlName="id7" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">Type 9</mat-label>
				<input maxlength="255" matInput formControlName="id8" />
			</mat-form-field>

			<div class="spacer"></div>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">Type 10</mat-label>
				<input maxlength="255" matInput formControlName="id9" />
			</mat-form-field>
		</div>

		<h3>{{ 'masterdata.racking.configs.sorting' | translate }}</h3>
		<div class="flex gap-24 pb-4">
			<mat-checkbox class="flex-1 mt-8" [(ngModel)]="sortingProfileLength" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.profileLength' | translate }}</mat-checkbox>
			<mat-checkbox class="mt-8" [(ngModel)]="sortingProfileLengthOrder" [ngModelOptions]="{standalone: true}" disabled="{{ !sortingProfileLength }}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.ascending' | translate }}</mat-checkbox>
			<mat-form-field [formGroup]="sortingPriorityForm" appearance="outline" class="dialog w-none min-w">
				@if (notuniqueError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.priority' | translate }}</mat-error>
				} @if (profileLengthMaxError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.configs.priority' | translate }}</mat-label>
				<input OnlyPositiveIntegers matInput formControlName="sortingProfileLengthPriority" (blur)="updateConfiguration()" (ngModelChange)="updatePriorityFormValidity()" [(ngModel)]="sortingProfileLengthPriority" />
			</mat-form-field>
		</div>
		<div class="flex gap-24 pb-4">
			<mat-checkbox class="flex-1 mt-8" [(ngModel)]="sortingProductionSequenceNumber" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.productionSequence' | translate }}</mat-checkbox>
			<mat-checkbox class="mt-8" [(ngModel)]="sortingProductionSequenceNumberOrder" [ngModelOptions]="{standalone: true}" disabled="{{ !sortingProductionSequenceNumber }}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.ascending' | translate }}</mat-checkbox>
			<mat-form-field [formGroup]="sortingPriorityForm" appearance="outline" class="dialog w-none min-w">
				@if (notuniqueError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.priority' | translate }}</mat-error>
				} @if (productionSequenceMaxError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.configs.priority' | translate }}</mat-label>
				<input OnlyPositiveIntegers matInput formControlName="sortingProductionSequenceNumberPriority" (blur)="updateConfiguration()" (ngModelChange)="updatePriorityFormValidity()" [(ngModel)]="sortingProductionSequenceNumberPriority" />
			</mat-form-field>
		</div>
		<div class="flex gap-24 pb-4">
			<mat-checkbox class="flex-1 mt-8" [(ngModel)]="sortingModelIndex" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.modelIndex' | translate }}</mat-checkbox>
			<mat-checkbox class="mt-8" [(ngModel)]="sortingModelIndexOrder" [ngModelOptions]="{standalone: true}" disabled="{{ !sortingModelIndex }}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.ascending' | translate }}</mat-checkbox>
			<mat-form-field [formGroup]="sortingPriorityForm" appearance="outline" class="dialog w-none min-w">
				@if (notuniqueError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.priority' | translate }}</mat-error>
				} @if (modelIndexMaxError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.configs.priority' | translate }}</mat-label>
				<input OnlyPositiveIntegers matInput formControlName="sortingModelIndexPriority" (blur)="updateConfiguration()" (ngModelChange)="updatePriorityFormValidity()" [(ngModel)]="sortingModelIndexPriority" />
			</mat-form-field>
		</div>

		<div class="flex gap-24 pb-4">
			<mat-checkbox class="flex-1 mt-8" [(ngModel)]="sortingSequenceNumber" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.sequence' | translate }}</mat-checkbox>
			<mat-checkbox class="mt-8" [(ngModel)]="sortingSequenceNumberOrder" [ngModelOptions]="{standalone: true}" disabled="{{ !sortingSequenceNumber }}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.ascending' | translate }}</mat-checkbox>
			<mat-form-field [formGroup]="sortingPriorityForm" appearance="outline" class="dialog w-none min-w">
				@if (notuniqueError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.priority' | translate }}</mat-error>
				} @if (sequenceNumberMaxError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.configs.priority' | translate }}</mat-label>
				<input OnlyPositiveIntegers matInput formControlName="sortingSequenceNumberPriority" (blur)="updateConfiguration()" (ngModelChange)="updatePriorityFormValidity()" [(ngModel)]="sortingSequenceNumberPriority" />
			</mat-form-field>
		</div>
		<div class="flex gap-24 pb-4">
			<mat-checkbox class="flex-1 mt-8" [(ngModel)]="sortingComponent" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.component' | translate }}</mat-checkbox>
			<mat-checkbox class="mt-8" [(ngModel)]="sortingComponentOrder" [ngModelOptions]="{standalone: true}" disabled="{{ !sortingComponent }}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.ascending' | translate }}</mat-checkbox>
			<mat-form-field [formGroup]="sortingPriorityForm" appearance="outline" class="dialog w-none min-w">
				@if (notuniqueError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.priority' | translate }}</mat-error>
				} @if (componentMaxError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.configs.priority' | translate }}</mat-label>
				<input OnlyPositiveIntegers matInput formControlName="sortingComponentPriority" (blur)="updateConfiguration()" (ngModelChange)="updatePriorityFormValidity()" [(ngModel)]="sortingComponentPriority" />
			</mat-form-field>
		</div>
		<div class="flex gap-24 pb-4">
			<mat-checkbox class="flex-1 mt-8" [(ngModel)]="sortingOperation" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.operation' | translate }}</mat-checkbox>
			<mat-checkbox class="mt-8" [(ngModel)]="sortingOperationOrder" [ngModelOptions]="{standalone: true}" disabled="{{ !sortingOperation }}" (ngModelChange)="updateConfiguration()">{{ 'masterdata.racking.configs.ascending' | translate }}</mat-checkbox>
			<mat-form-field [formGroup]="sortingPriorityForm" appearance="outline" class="dialog w-none min-w">
				@if (notuniqueError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.priority' | translate }}</mat-error>
				} @if (operationMaxError) {
				<mat-error>{{ 'masterdata.racking.configs.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.configs.priority' | translate }}</mat-label>
				<input OnlyPositiveIntegers matInput formControlName="sortingOperationPriority" (blur)="updateConfiguration()" (ngModelChange)="updatePriorityFormValidity()" [(ngModel)]="sortingOperationPriority" />
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.cutting.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || !isFormValid" [ngClass]="{ 'disabled-button': loading }">{{ 'masterdata.cutting.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
